module.exports = __webpack_public_path__ + "img/keys.ae838bed.png";